import Lessons from './Lessons.vue';

export * from './types';
export default Lessons;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/lessons/index.ts